
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/research/data",
      function () {
        return require("private-next-pages/research/data.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/research/data"])
      });
    }
  